import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as TrashSVG } from 'Images/icon-action-bar-trash.svg';

export const Wrapper = styled.div`
  cursor: pointer;
  display: none;
  position: absolute;
  right: 4px;
  top: 4px;
  padding: 0px 4px 3px 4px;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgb(28 34 67 / 3%);
  border: solid 1px #d9e4ef;
  background-color: ${colors.white};
`;
Wrapper.displayName = 'Wrapper';

export const TrashIcon = styled(TrashSVG)`
  width: 16px;
  height: 17px;
  margin: auto 0px auto auto;
  * > path {
    fill: ${colors.blueGrey};
  }
`;

TrashIcon.displayName = 'TrashIcon';
